






























import { Component, Vue, Emit, Prop } from 'vue-property-decorator'

@Component

export default class ComponentAgendamentoList extends Vue {
  @Prop({ type: Array, required: false }) dates: []
  @Prop(String) title
  @Prop(String) text
  @Prop(String) subText
  @Prop(Boolean) disabledButton

  @Emit('listMethodClick')
  listMethodClick(value) {

  }
}
